import * as browser from "webextension-polyfill";
const userIdStorageKey = "userid";
let userIdPromise = null;
function generateRandomId() {
    const alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
    const targetLength = 16;
    const result = [];
    const uint8Length = 256;
    const maxUnbiased = uint8Length - (uint8Length % alphabet.length);
    while (result.length < targetLength) {
        const randomBytes = new Uint8Array(targetLength);
        crypto.getRandomValues(randomBytes);
        for (const byte of randomBytes) {
            if (byte < maxUnbiased) {
                result.push(alphabet[byte % alphabet.length]);
                if (result.length === targetLength) {
                    break;
                }
            }
        }
    }
    return result.join("");
}
export function getUserId() {
    if (userIdPromise) {
        return userIdPromise;
    }
    userIdPromise = (async () => {
        const response = await browser.storage.local.get(userIdStorageKey);
        const value = response[userIdStorageKey];
        if (value) {
            return String(value);
        }
        const newUserId = generateRandomId();
        await browser.storage.local.set({ [userIdStorageKey]: newUserId });
        return newUserId;
    })();
    return userIdPromise;
}
